import { Component, OnInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AuthenticationService } from '../_services/authentication.service';
import { MessageService } from '../message/message.service';
import { LoaderService } from 'src/app/loader/loader.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['../auth-layout/auth-layout.component.css'],
})
export class LoginComponent implements OnInit {
	loginForm;
	public showPassword: boolean;
	public showPasswordOnPress: boolean;

	constructor(
		private auth: AuthenticationService,
		private MessageService: MessageService,
		private form: FormBuilder,
		public loaderService: LoaderService,
		private renderer: Renderer2
	) {
		this.loginForm = this.form.group({
			username: '',
			password: '',
		});
	}

	ngOnInit(): void {
		document.body.classList.add('login-page');

		const savedSettings = localStorage.getItem('userSettings') ?? null;
		localStorage.clear();
		if (savedSettings) localStorage.setItem('userSettings', savedSettings);
	}
	ngOnDestroy(): void {
		document.body.classList.remove('login-page');
	}
	login() {
		this.MessageService.sendMessage(null);
		const payload = {
			username: (this.loginForm.get('username').value || '').trim(),
			password: this.loginForm.get('password').value || '',
		};
		this.auth.login(payload).subscribe(
			(data) => {
				this.MessageService.sendMessage(data);
			},
			(error) => {
				console.log(error);
			}
		);
	}
}
